import { ref } from 'vue';

/**
 * Hover readouts for the hand drawn SVG charts. Every hoverable shape carries its text in a
 * `data-tip` attribute, so a chart only has to render the attribute and delegate the pointer
 * events here - there is no per-shape listener and no HTML in the tooltip.
 */
export function useChartTooltip() {
  const tooltip = ref({ visible: false, x: 0, y: 0, content: '' });

  const onPointerMove = event => {
    const target = event.target.closest?.('[data-tip]');
    if (!target) {
      tooltip.value = { ...tooltip.value, visible: false };
      return;
    }

    tooltip.value = {
      visible: true,
      x: event.clientX,
      y: event.clientY - 12,
      content: target.dataset.tip,
    };
  };

  const onPointerLeave = () => {
    tooltip.value = { ...tooltip.value, visible: false };
  };

  return { tooltip, onPointerMove, onPointerLeave };
}
